//#region src/components/ui/carousel/locale/en_US.ts
var e = {
	previousSlide: "Previous Slide",
	nextSlide: "Next Slide"
};
//#endregion
export { e as carouselLocale };

//# sourceMappingURL=en_US.js.map